import { UserRole } from "../../../../../store/store.model";
export function isValidWorkspace(workspace) {
  if (workspace.role === UserRole.Accountant) {
    // You can switch to a workspace where you are an accountant only from the contacts dashboard.
    return false;
  }

  return workspace.features.accountsPayable || workspace.features.accountsReceivable && workspace.setupCompleted;
}